function defaultPopupOpen(){
if (window.location.hash === "#popup") {
    var popupLink = document.querySelector('a[href="#popup"]');
    if (popupLink) {
      popupLink.click();
    }
  }
}

defaultPopupOpen();

function getHeaderOffset() {
	let headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim().replace('px', '');
	return parseInt(headerHeight) || 0;
}

function scrollToSection(){
    let hash = window.location.hash.replace("#", "");
    if (!hash) return;

    let target = document.getElementById(hash);
    if (!target) return;

    let offset = getHeaderOffset();
    let y = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: y, behavior: "smooth" });
}

setTimeout(() => {
    scrollToSection();
}, 555);

if(document.querySelector('.open_popup_js')){
  document.querySelectorAll('.open_popup_js').forEach(function(popupOpen){
    popupOpen.addEventListener('click', function (){
      if(document.querySelector(".lab_report_popup_main")){
        document.querySelector(".lab_report_popup_main").classList.add("active");
      }
      if(document.querySelector(".overlay")){
        document.querySelector(".overlay").classList.remove("hidden");
      }
    });
  });
}

if(document.querySelector('.lab_report_popup_main .close_popup_JS')){
  document.querySelectorAll('.lab_report_popup_main .close_popup_JS').forEach(function(closePopup){
    closePopup.addEventListener('click', function (){
      if(closePopup.closest(".lab_report_popup_main")){
        closePopup.closest(".lab_report_popup_main").classList.remove("active");
      }
      if(document.querySelector(".overlay")){
        document.querySelector(".overlay").classList.add("hidden");
      }
    });
  });
}

if(document.querySelector(".product form.form") && document.querySelector(".sticky_atc_main")){
  var productForm = document.querySelector(".product form.form"),
      stickyBar = document.querySelector(".sticky_atc_main"),
      stickyAtcObserver = new IntersectionObserver(
          (entries) => {
              entries.forEach((entry) => {
                  if ( !entry.isIntersecting && entry.boundingClientRect.top <= 0 ) {
                      stickyBar.classList.add("active");
                  } 
                  else {
                      stickyBar.classList.remove("active");
                  }
              });
          },
          {
              threshold: 0.1
          }
      );
  
  stickyAtcObserver.observe(productForm);   

  document.querySelectorAll(".sticky_atc_main .atc_js").forEach(function(atcBTN){
    atcBTN.addEventListener("click",function(){
      if(productForm.querySelector(".product-form__buttons .product-form__submit")){
        productForm.querySelector(".product-form__buttons .product-form__submit").click();
        atcBTN.classList.add("loading");
        if(atcBTN.querySelector(".loading__spinner")){
          atcBTN.querySelector(".loading__spinner").classList.remove("hidden");
        }
      }
    });
  });
}
   
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  var variant = event.data.variant;
  setStickyAtc(variant);
});

function setStickyAtc(variant){
    if(document.querySelector(".sticky_atc_main")){
        if(variant.available){
          document.querySelector(".sticky_atc_main .sticky_atc_btns .button").classList.remove("disabled");
          document.querySelector(".sticky_atc_main .sticky_atc_btns .button .text").innerHTML = window.variantStrings.addToCart;
        }else{
          document.querySelector(".sticky_atc_main .sticky_atc_btns .button").classList.add("disabled");
          document.querySelector(".sticky_atc_main .sticky_atc_btns .button .text ").innerHTML = window.variantStrings.soldOut;
        }
    }
}